(() => {
  const promotions = window.theme?.automaticGiftPromotions;
  if (!Array.isArray(promotions) || promotions.length === 0) return;

  let activeSync;

  const fetchCart = async () => {
    const response = await fetch(`${theme.routes.cart_url}.js`, {
      headers: { Accept: 'application/json' }
    });
    if (!response.ok) throw new Error('Unable to read cart for Hair Oil gift');
    return response.json();
  };

  const changeCart = async (body) => {
    const response = await fetch(theme.routes.cart_change_url, {
      ...fetchConfig('javascript'),
      body: JSON.stringify(body)
    });
    if (!response.ok) throw new Error('Unable to update Hair Oil gift');
    return response.json();
  };

  const addGift = async (promotion, quantity, sections, sectionsUrl) => {
    const response = await fetch(theme.routes.cart_add_url, {
      ...fetchConfig('javascript'),
      body: JSON.stringify({
        items: [{
          id: promotion.giftVariantId,
          quantity,
          properties: {
            [promotion.propertyName]: promotion.propertyValue
          }
        }],
        sections,
        sections_url: sectionsUrl
      })
    });
    if (!response.ok) throw new Error('Unable to add Shampoo Mini gift');
    return response.json();
  };

  const isPromotionalGift = (item, promotion) => {
    return String(item.variant_id) === String(promotion.giftVariantId)
      && (
        item.properties?.[promotion.propertyName] === promotion.propertyValue
        || item.properties?.[promotion.legacyPropertyName] === promotion.propertyValue
      );
  };

  theme.syncAutomaticGifts = ({ cart, sections = [], sectionsUrl = window.location.pathname } = {}) => {
    if (activeSync) {
      return activeSync.then(() => theme.syncAutomaticGifts({ sections, sectionsUrl }));
    }

    activeSync = (async () => {
      let currentCart = cart?.items ? cart : await fetchCart();
      let changed = false;
      let mutationState;

      for (const promotion of promotions) {
        const triggerVariantIds = promotion.triggerVariantIds.map(String);
        const targetQuantity = currentCart.items.reduce((total, item) => {
          return triggerVariantIds.includes(String(item.variant_id))
            ? total + item.quantity
            : total;
        }, 0);
        let giftLines = currentCart.items.filter((item) => isPromotionalGift(item, promotion));
        const currentGiftQuantity = giftLines.reduce((total, item) => total + item.quantity, 0);

        if (giftLines.length === 1 && currentGiftQuantity === targetQuantity) continue;
        if (giftLines.length === 0 && targetQuantity === 0) continue;

        // Shopify can split one discounted line into free and paid portions
        // after a trigger quantity drops. Remove every old gift line first so
        // the replacement is created at the exact eligible quantity.
        while (giftLines.length > 0) {
          const giftLineIndex = currentCart.items.findIndex((item) => isPromotionalGift(item, promotion));
          mutationState = await changeCart({
            line: giftLineIndex + 1,
            quantity: 0,
            sections,
            sections_url: sectionsUrl
          });
          changed = true;
          currentCart = await fetchCart();
          giftLines = currentCart.items.filter((item) => isPromotionalGift(item, promotion));
        }

        if (targetQuantity > 0) {
          mutationState = await addGift(promotion, targetQuantity, sections, sectionsUrl);
          changed = true;
          currentCart = await fetchCart();
        }
      }

      if (changed) {
        currentCart.sections = mutationState?.sections || {};
      }

      return { cart: currentCart, changed };
    })().finally(() => {
      activeSync = undefined;
    });

    return activeSync;
  };
})();
